<template>
  <div class="input-close-wrap">
    <input
      v-cursor-end
      class="app-t-input"
      type="text"
      enterkeyhint="done"
      :value="inputUserInfo"
      @keyup.enter.prevent="(e) => (e.target as HTMLInputElement).blur()"
      @input="handleInput"
    />

    <button v-if="!isInputEmpty" type="button" class="close" @click="reset">
      <img :src="getAssetImageUrl('common/icons/close.svg')" alt="" />
    </button>
  </div>

  <div class="btn-area">
    <button
      type="button"
      class="l-btn primary-btn"
      :disabled="isInputEmpty"
      @click="$emit('confirm', inputUserInfo.trim())"
    >
      <span>{{ t('label_change') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const props = withDefaults(
  defineProps<{
    payload?: string;
  }>(),
  {
    payload: '',
  }
);

const inputUserInfo = ref(props.payload);
defineEmits(['confirm', 'close']);

const { t } = useI18n();

const isInputEmpty = computed(() => {
  return !inputUserInfo.value.trim();
});

const handleInput = (e: Event) => {
  inputUserInfo.value = (e.target as HTMLInputElement).value;
};

const reset = () => {
  inputUserInfo.value = '';
};
</script>

<style scoped lang="scss">
.input-close-wrap {
  margin: 2rem 0;
  .app-t-input {
    padding-right: 2.75rem;
  }
  position: relative;
  .close {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.25rem;
  }
}
</style>
